import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import LibraryService from "../../../../../services/LibraryService/LibraryService"
import SelectInput from "../../../../../components/SelectInput/SelectInput";
import RichTextEditor from "react-rte";
const StepSelectLocalAction = ({ publishDetail, setIsRequired, setPublishDetail, checkAndSetVariables, setHasApplicationJson }) => {
    // Assign initial values to hooks

    const { t } = useTranslation();
    const [select, setSelect] = useState(publishDetail.publish_detail.action_id ? publishDetail.publish_detail.action_id : "");
    const [selectData, setSelectData] = useState([]);
    const [state, setState] = useState(publishDetail.publish_detail.status ? publishDetail.publish_detail.status : '');

    useEffect(() => {
        if (state === 'new_action') {
            setIsRequired(false);
        } else if (state === 'current_action') {
            setIsRequired(select.length > 0 ? false : true);
            const fetchData = async () => {
                const libraryId = publishDetail.publish_detail.library.id;
                const libraryVersionId = publishDetail.publish_detail.library.library_version_id;
                const { data } = await LibraryService.listLibraryAction(libraryId, libraryVersionId);
                if (Array.isArray(data)) {
                    setSelectData(data);
                }
            }
            fetchData().then(r => r);
        } else {
            setIsRequired(true);
        }

    }, [state])

    // Handle checkbox values changes
    const handleChange = (e) => {
        setState(e.target.name);
        if (e.target.name === 'new_action') {
            setPublishDetail(oldState => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    status: e.target.name,
                    name: '',
                    action_id: '',
                    short_description: '',
                    configuration: '',
                }
            }))
        } else {
            setPublishDetail(oldState => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    status: e.target.name,
                }
            }))
        }
    }

    const updateActionDetail = (actionDetail) => {
        setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                name: actionDetail.action_name,
                action_id: actionDetail.id,
                short_description: RichTextEditor.createValueFromString(actionDetail.action_description, "html"),
                configuration: RichTextEditor.createValueFromString(actionDetail.configuration, "html")
            }
        }))
        if (setHasApplicationJson) {
            setHasApplicationJson(actionDetail.aafc_id ? true : false)
        }
        checkAndSetVariables(actionDetail.action_flow_details.variables);
    }

    const handleSelect = async ({ target: { value } }) => {
        if (value !== '') {
            const { data } = await LibraryService.getActionDetail(value);
            if (data) {
                setSelect(value);
                updateActionDetail(data);
                setIsRequired(false);
                return
            } else {
                // hata var
            }
        } else {
            setSelect('');
        }
        setIsRequired(true);
    }

    return (
        <div style={{ width: '100%' }}>
            <div className="form-element">
                <label>Action Type</label>
                <div className="steps-tabs">
                    <div className={state === 'new_action' ? "steps-tabs-button-active" : "steps-tabs-button"}>
                        <input type="checkbox" style={{ display: 'none' }}
                            name="new_action" onChange={handleChange}
                            id="publish-rpa-check" checked={state.new_action} />
                        <label style={{
                            cursor: 'pointer',
                            width: "100%",
                            textAlign: "center"
                        }} htmlFor="publish-rpa-check" >
                            <span style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{t("CONTENT.PUBLISH.NEW-ACTION")}</span>
                        </label>
                    </div>
                    <div className={state === 'current_action' ? "steps-tabs-button-active" : "steps-tabs-button"}>
                        <input type="checkbox" style={{ display: 'none' }}
                            name="current_action" onChange={handleChange}
                            id="publish-ipaas-check" checked={state.current_action} />
                        <label style={{
                            cursor: 'pointer',
                            width: "100%",
                            textAlign: "center"
                        }}
                            htmlFor="publish-ipaas-check"
                        >
                            <span style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{t("CONTENT.PUBLISH.CURRENT-ACTION")}</span>
                        </label>
                    </div>
                </div>
                {
                    state === 'current_action' &&
                    <div className="form-element">
                        <label>Choose Action</label>
                        <SelectInput value={select} param="action_name" onChange={handleSelect} data={selectData} name="action_name" valueKey="id" />
                        <div><small>{t("CONTENT.PUBLISH.SELECT-ACTION-YOU-WANT-TO-UPDATE-FROM-LOCAL")}</small></div>
                    </div>
                }
            </div>


        </div>
    );
};


export default StepSelectLocalAction;
